export default __webpack_public_path__ + "static/media/s-3.af6aa55e.jpg";